import { Component, OnInit } from '@angular/core';
import { ApiService } from '../services/api/api.service';
import { ActivatedRoute } from '@angular/router';
import { File } from '@ionic-native/file/ngx';
import { FileTransfer, FileUploadOptions, FileTransferObject } from '@ionic-native/file-transfer/ngx';
import { DomSanitizer } from '@angular/platform-browser';

declare var Ionic: any
@Component({
  selector: 'app-order-details',
  templateUrl: './order-details.page.html',
  styleUrls: ['./order-details.page.scss'],
})
export class OrderDetailsPage implements OnInit {
  sub:any
  OrderDetails:any = ''
  catgItemList:any = ''
  filelocation:any = ''
  DownloadPath:any = ''
  DeliveryDate:any = ''
  DeliveredDate:any = ''
  currencySymbol:any = ''
  shopName:any = ''
  constructor(public api: ApiService,private route: ActivatedRoute,private file: File,private transfer: FileTransfer,private sanitizer: DomSanitizer) {
    // this.DownloadPath = this.api.getDownloadPath();
    this.sub = this.route.params.subscribe(params => {
        this.OrderDetails = JSON.parse(params['item']);
        this.catgItemList = this.OrderDetails.cart_items
        this.currencySymbol = this.OrderDetails.cart_items.current_currency_symbol
        this.shopName = this.OrderDetails.store_details.store_name
        if(this.OrderDetails.delivery_details.zip_code_details){
          if(this.OrderDetails.delivery_details.zip_code_details.expected_delivery_date != undefined){
            this.DeliveryDate = this.OrderDetails.delivery_details.zip_code_details.expected_delivery_date.delivery_display_text.split('-')
            this.DeliveryDate = this.DeliveryDate[1]
          }
          else{
            this.DeliveryDate = ''
          }
        }
        else {
          this.DeliveryDate = ''
        }

        if(this.OrderDetails.delivered_on != null){
          this.DeliveredDate = this.OrderDetails.delivered_on
        }
        // for(let i = 0; i < this.catgItemList.cart_items.length; i++){
        //   let imgFileName:any = this.catgItemList.cart_items[i].product_details[0].product_icon
        //   imgFileName = imgFileName.split('/')
        //   imgFileName = imgFileName[imgFileName.length-1]
        //   this.checkDirectory(imgFileName,this.catgItemList.cart_items[i].product_details[0].product_icon)
        // }
      });
   }

  ngOnInit() {
    // this.ga.trackView('Order Detail Page')
    // .then(() => {})
    // .catch(e => console.log(e));
  }

  logRatingChange(rating){
    console.log("changed rating: ",rating);
    // do your stuff
}

  getDeliveryDate(value:any){
    if(value){
      var x = new Date(value)
      return x.toDateString()
    }
    else {
      return ''
    }
  }

  getOrderStatus(value:any){
    if(value == 1){
      return "Placed"
    }
    else if(value == 2){
      return "In-Progress"
    }
    else if(value == 3){
      return "Delivered"
    }
    else if(value == 4){
      return "Received"
    }
    else if(value == 0){
      return "Pending"
    }
  }

  // checkDirectory(fileName:any,url:any){
  //   this.file.checkFile(this.file.cacheDirectory, fileName).then(_ => console.log('File exists')).catch((err:any)=>{
  //     console.log("File doesn't exist");
  //     this.downloadImages(fileName,url)
  //   });
  // }
  
  // tempFileCheck:any = false
  // async downloadImages(fileName:any,url:any) {
  //   return new Promise((resolve, reject) => {
  //     const fileTransfer: FileTransferObject = this.transfer.create();
  //     let data = [];
  //     data.push(new Promise((resolve, reject) => {
  //     resolve( fileTransfer.download(url, this.file.cacheDirectory + fileName).then((entry) => {
  //       this.tempFileCheck = true
  //     console.log('download complete: ' + entry.toURL());
  //     }))
  //   }))
  //     Promise.all(data).then((values) => {
  //         resolve(values)
  //     });
  //   })
  // }

  // openImage(img:any){
  //   let imgFileName:any = img
  //   imgFileName = imgFileName.split('/')
  //   imgFileName = imgFileName[imgFileName.length-1]
  //   // return this.sanitizer.bypassSecurityTrustUrl(Ionic.WebView.convertFileSrc(this.file.cacheDirectory+imgFileName))
  //   return Ionic.WebView.convertFileSrc(this.file.cacheDirectory+imgFileName)
  // }

}
